import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../services/app-config.service';
import { Observable, throwError } from 'rxjs';
import { InsightsUtility } from '../utilities/insights/insights.utility';
import { GeneralError } from '../insights/errors/general.error';

@Injectable({
	providedIn: 'root'
})
export class RecoveryManager {
	constructor(
		private http: HttpClient,
		private appConfigService: AppConfigService,
		private insightsUtility: InsightsUtility) {
	}

	public handleError(details: ErrorLogEntry): Observable<never> {
		return throwError(() => {
			this.trackLogEntry(details);
			return new Error(details?.message);
		});
	}

	private trackLogEntry(details: ErrorLogEntry): void {
		setTimeout(() => {
			this.insightsUtility.event(new GeneralError({
				message: details?.message || 'An unexpected error has occurred.',
				internalError: details.internalError
			}));
		});
	}
}

interface ErrorLogEntry {
	message: string;
	errorType: 'fatal' | 'recoverable';
	internalError: Error;
	context?: {
		caseId?: string;
		documentId?: string;
		userId?: string;
	};

}
